<template>
  <div class="date-not-available-banner" v-if="!isFromSearch">
    We’re sorry, but the selected dates are not available right now. Don’t worry you can update your dates <b @click="scrollTo">here</b> or
    <a :href="searchUrl">find other nearby properties here</a>
  </div>
</template>

<script>
export default {
  props: {
    town: String,
    nights: String,
    checkInDate: String,
    checkOutDate: String,
  },
  data: function () {
    return {
      searchUrl: "/searches/custom?search[region]=",
      isFromSearch: document.referrer.indexOf('searches') > -1 || document.referrer.indexOf('top-deals') > -1 || document.referrer.indexOf('properties') > -1,
    }
  },
  methods: {
    scrollTo() {
      this.$emit('scrollTo', 'availability-block', -20);
    },
  },
  beforeMount() {
    let checkIn = new Date(this.checkInDate).toLocaleDateString('fr-CA');
    // fr-CA will give date as YYYY-MM-DD
    this.searchUrl = this.searchUrl + this.town + "&search[check_in_on]=" + checkIn + "&search[minimum_nights]=" + this.nights
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.date-not-available-banner {
  padding: 1rem;
  color: #D22F30;
  margin: 1.25rem;
  line-height: 1rem;
  font-size: 0.875rem;
  background: #FFF8DC;
  border-radius: 0.25rem;
  border: 1px solid #FFDE5A;

  a {
    color: #424F98;
    font-weight: 700;
  }

  b {
    color: #424F98;
    cursor: pointer;
    font-weight: 700;
    text-decoration: underline;
  }

  @media #{$desktop} {
    margin: 0 0 1.25rem 0;
  }
}
</style>